import { useDeals } from '@finn/platform-modules';
import dayjs from 'dayjs';
import { useEffect, useMemo } from 'react';

const MAX_DAYS_BEFORE_RETURN = 121;
const MIN_DAYS_BEFORE_RETURN = 14;

export const useReadyForRetentionDeals = () => {
  const { activeDeals, dealsStatus } = useDeals();

  // copying the logic in visibility config of this cosmic object used in CP -> 6784d8a75ecdabfe037a9b42
  const activeSubscriptions = useMemo(
    () =>
      activeDeals?.filter((deal) => {
        const isSubscribedTo = ['SWAP_SAME_DAY', 'PROLONGATION'].includes(
          deal.subscribed_to ?? ''
        );
        if (isSubscribedTo) {
          return false;
        }
        if (deal.state === 'CREATED') {
          return false;
        }
        const endDate = dayjs(deal.return_date || deal.end_date);

        return (
          endDate.isAfter(dayjs().add(MIN_DAYS_BEFORE_RETURN, 'day')) &&
          endDate.isBefore(dayjs().add(MAX_DAYS_BEFORE_RETURN, 'day'))
        );
      }),
    [activeDeals]
  );

  const firstActiveSubscriptionId = activeSubscriptions?.[0]?.id;

  // setting the first active subscription ID in localStorage to use
  // it for swap-suggestion in case a specific subscription is not selected
  useEffect(() => {
    localStorage.setItem('finn_f_sub_id', firstActiveSubscriptionId || '');
  }, [firstActiveSubscriptionId]);

  return { activeSubscriptions, dealsStatus };
};
